<template>
  <div :class="classList">
    <template v-if="fixed">
      <div class="x-w-ctn">
        <slot></slot>
      </div>
    </template>
    <template v-else>
      <slot></slot>
    </template>
    <div class="menu_wkBox_back_box"></div>
  </div>
</template>
<script>
export default {
  name: 'XWrapper',
  props: {
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      classList: []
    }
  },
  created() {
    if (this.fixed) {
      this.classList.push('x-wrapper-fixed')
    }
  }
}
</script>
<style lang="scss" scoped>
.x-wrapper-fixed {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  .x-w-ctn {
    min-height: 1rem;
  }
  background: #fff;
}
</style>
